export default "__VITE_ASSET__BX8wxem8__"